import React from 'react'
import { useDispatch } from 'react-redux';
import Version from "../../Version";

const UndoRedoComponent = (props) => {
  const dispatch = useDispatch();
  
  const onClickUndo = () => {
    Version.undo(dispatch, props)
  }

  const onClickRedo = () => {
    Version.redo(dispatch, props)
  }

  return (
    <>
      <button className="undo-btn" onClick={onClickUndo} disabled={!props.canUndo}>
        <i className="icon-circle-arrow-left"></i> Undo
      </button>
      <button className="undo-btn" onClick={onClickRedo} disabled={!props.canRedo}>
        <i className="icon-circle-arrow-right"></i> Redo
      </button>
    </>
  )
}

export default UndoRedoComponent;